<span
  class="expression-keyword"
  popoverClass="keyword-popover"
  [ngbPopover]="inputtemplate"
  [autoClose]="'outside'"
  [placement]="'bottom'"
  (hidden)="handlePopoverClose()"
  [ngClass]="{
    'expression-keyword--error': hasValidationError,
  }"
  [attr.data-automation]="'natural-language-editor-double-' + phraseId()"
>
  {{ (entityPrimaryDropdownValue?.label ?? '') + ' ' + (entity?.secondary ?? '') }}
</span>

<ng-template #inputtemplate>
  <div class="p-2" data-automation="natural-language-editor-double-popover">
    <div>
      <label class="form-label" for="input-dropdown" data-automation="natural-language-editor-double-primary-label">
        {{ primaryDropdownLabel() | translate }}
      </label>
      <ng-select
        [attr.data-automation]="'natural-language-editor-double-primary-dropdown'"
        [items]="options()"
        [clearable]="false"
        [searchable]="false"
        [labelForId]="'input-dropdown'"
        [(ngModel)]="primaryDropdownValue"
        (ngModelChange)="onPrimaryDropdownChange()"
        bindLabel="label"
        class="input-dropdown"
      >
        <ng-template ng-option-tmp let-item="item">
          <ng-template #tipContent>
            <span>{{ item.disabledTooltip | translate }}</span>
          </ng-template>
          <span [ngbTooltip]="tipContent" [container]="'body'" [disableTooltip]="!item.disabled" class="d-flex">
            <span class="ng-option-label">{{ item.label | translate }}</span>
          </span>
        </ng-template>
      </ng-select>
    </div>
    @if (primaryDropdownValue.secondaryInputConfiguration.type !== 'none') {
      <div class="mt-3" [ngClass]="{ 'has-feedback ziro-forms-error': validationMessage }">
        <div>
          <label class="form-label" for="textfield-input">
            <span class="text-danger">*</span>
            <span data-automation="natural-language-editor-double-secondary-label">
              {{ primaryDropdownValue.secondaryInputConfiguration.label | translate }}
            </span>
          </label>
        </div>
        <div>
          @if (primaryDropdownValue.secondaryInputConfiguration.type === 'text') {
            <input
              type="text"
              id="textfield-input"
              [(ngModel)]="secondaryInputValue"
              (ngModelChange)="onSecondaryInputChange()"
              [placeholder]="primaryDropdownValue?.secondaryInputConfiguration.placeholder"
              class="form-control"
              data-automation="natural-language-editor-double-secondary-input"
            />
          }
          @if (primaryDropdownValue.secondaryInputConfiguration.type === 'search') {
            <div class="keyword-search input-group" [ngClass]="{ 'has-feedback ziro-forms-warning': isSearching }">
              <span class="{{ ziroIcons.SEARCH }} form-control-feedback form-control-feedback--left"></span>
              <ng-select
                [(ngModel)]="secondaryInputValue"
                (ngModelChange)="onSecondaryInputChange()"
                [searchable]="true"
                [clearable]="false"
                [typeahead]="typeahead$"
                [placeholder]="primaryDropdownValue?.secondaryInputConfiguration.placeholder"
                [items]="searchOptions$ | async"
                [minTermLength]="primaryDropdownValue.secondaryInputConfiguration.minSearchLength ?? 3"
                [loading]="isSearching"
                loadingText="{{ 'tkey;global.searching.helpblock' | translate }}..."
                data-automation="natural-language-editor-double-secondary-dropdown"
              >
                <ng-template ng-typetosearch-tmp>
                  <div class="d-none"></div>
                </ng-template>
              </ng-select>
            </div>
          }
          @if (validationMessage) {
            <span class="small" data-automation="natural-language-editor-double-secondary-feedback">
              {{ validationMessage | translate }}
            </span>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
